import { configureStore } from '@reduxjs/toolkit';
import adminReducer from '../Pages/AdminProfile/adminSlice/adminSlice';


export const store = configureStore({
    reducer: {
       admin: adminReducer,
    }
});

export default store;
